export enum UserType {
  CUSTOMER_SUPPORT = 'CustomerSupport',
  FACILITY_ADMIN = 'FacilityAdmin',
  TECHNICAL_USER = 'TechnicalUser',
}

export interface Facility {
  id: string;
  apiClientId: string;
}

export interface User {
  id: string;
  type: UserType;
  facilities: Facility[];
}
